import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const ArrowLeft = createSvgIcon(
  () => (
    <path d="M25.1465 39.8193C26.123 38.8428 26.0254 37.3779 25.1465 36.4014L13.3301 25.1709H41.4551C42.7246 25.1709 43.7988 24.1943 43.7988 22.8271V19.7021C43.7988 18.4326 42.7246 17.3584 41.4551 17.3584H13.3301L25.1465 6.22559C26.0254 5.24902 26.123 3.78418 25.1465 2.80762L22.998 0.65918C22.1191 -0.219727 20.5566 -0.219727 19.6777 0.65918L0.732422 19.7021C-0.244141 20.5811 -0.244141 22.0459 0.732422 22.9248L19.6777 41.9678C20.5566 42.8467 22.0215 42.8467 22.998 41.9678L25.1465 39.8193Z" />
  ),
  '0 0 44 43'
);
